export function uniq<T>(list: T[]) {
  return Array.from(new Set<T>(list))
}
